import { SET_WAREHOUSE, SET_WAREHOUSES } from "../../constants/warehouseConstants";

export const setWarehouse = (warehouse) => {
  return {
    type: SET_WAREHOUSE,
    warehouse,
  };
};

export const setWarehouses = (warehouses, filtered = false) => {
  return {
    type: SET_WAREHOUSES,
    warehouses,
    filtered,
  };
};
